<template>
    <div class="value-switch" :style="{ '--options': options.length, '--selected': valueIndex }">
        <div v-for="option in options"
             :key="option.value"
             :class="['option', { 'selected': option.value == value }]"
             @click="setValue(option.value)">
            {{ option.label }}
        </div>
    </div>
</template>

<script lang="ts">
    import Vue, { PropType } from 'vue';

    export default Vue.extend({
        name: 'value-switch',
        props: {
            value: [Number, Boolean, String],
            options: Array as PropType<{ value: any, label: string }[]>
        },
        computed: {
            valueIndex(): number {
                return this.options.findIndex(op => op.value == this.value);
            },
        },
        methods: {
            setValue(value: any) {
                this.$emit('input', value);
            }
        }
    });

</script>

<style scoped lang="scss">

    .value-switch {
        height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        border: 2px solid var(--background-grey-3);
        border-radius: 20px;
        background-color: var(--background-grey-3);
        box-sizing: border-box;
        outline: none;
        position: relative !important;

        .option {
            cursor: pointer;
            @extend %body-14-24-regular;
            @extend %no-overflow;
            padding: 6px 16px;
            text-align: center;
            width: 100%;
            z-index: 2;
            transition: color .2s;

            &.selected {
                color: var(--primary-500);
                font-weight: 500;
            }
        }

        &::before {
            --width: calc(100% / var(--options));
            content: '';
            display: block;
            width: var(--width);
            height: 100%;
            position: absolute;
            top: 0;
            left: calc(var(--selected) * var(--width));
            z-index: 1;
            border-radius: 20px;
            background-color: var(--white);
            box-shadow: 0px 0px 0px 1px rgba(66,66,66,0.15), 0px 1px 3px rgba(66,66,66,0.25);
            transition: left .2s;
        }

        &[size="mini"] {
            height: 32px;

            & .option {
                padding-top: 2px;
                padding-bottom: 2px;
            }
        }
    }

</style>